import { DebtAttributes } from '~/shared/api'
import { formatDateTimeForUI } from '~/shared/lib/date'
import { parseSumForUi } from '~/shared/lib/utils'
import { ChevronRightIcon } from '~/shared/ui/icons'
import { myPalette } from '~/shared/ui/theme'
import {
  Title,
  Wrapper,
  GridItemTitle,
  GridItemValue,
  GridContainer,
} from './styled'

type CardProps = {
  debtId: UniqueId
  attributes: DebtAttributes
}

export function Card({ debtId, attributes }: CardProps) {
  return (
    <Wrapper to={`/debts/${debtId}`}>
      <Title>
        Задолженность от{' '}
        {attributes.createdAt ? formatDateTimeForUI(attributes.createdAt) : '-'}
        <ChevronRightIcon color={myPalette.white.main} />
      </Title>

      <GridContainer>
        <div>
          <GridItemTitle>Сумма</GridItemTitle>
          <GridItemValue>{parseSumForUi(attributes.total)}</GridItemValue>
        </div>
        <div>
          <GridItemTitle>В день</GridItemTitle>
          <GridItemValue>{parseSumForUi(attributes.paymentCost)}</GridItemValue>
        </div>
        <div>
          <GridItemTitle>Осталось</GridItemTitle>
          <GridItemValue style={{ color: myPalette.coral.main }}>
            {parseSumForUi(attributes.remainingAmount)}
          </GridItemValue>
        </div>
      </GridContainer>
    </Wrapper>
  )
}
